function fn_comp_contact() {

    var $fn = $("#comp-detail");

    if ($fn.length) {
        if(window.location.hash === "#recenze") {
            $('html, body').animate({
                scrollTop: $("#anchor-detail").offset().top - 5
            }, 0);

            setTimeout(function () {
                $fn.find('[data-target="reviews"]').click();
            },5);
        }
    }
}
